import React, { Component } from 'react'
import { Table, Button, Row, Icon, Modal } from "antd"
import { observer, inject } from "mobx-react"
import { withRouter } from "react-router-dom"
import TaskDetail from 'app/components/normal/pgs/TaskDetail'

@inject("auth") @observer
class DataTable extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showTaskDetailModal: false
    }
  }
  componentDidMount() {
    const { getTableData } = this.props.store
    getTableData()
  }

  openDetail = (id) => {
    const { getDetailData, setDetailDataId } = this.props.store
    setDetailDataId(id)
    getDetailData(id)
      .then(res => {
        this.showModal('showTaskDetailModal')
      })
  }

  onPaginChange = selectedPageNumber => {
    let {
      store: {
        changePagin
      },
    } = this.props

    changePagin(selectedPageNumber)

    document.getElementById("contentTop").scrollIntoView(true)
  }

  showModal = (field) => {
    this.setState({
      [field]: true
    })
  }

  closeModal = (modal, cb = () => { }) => {
    this.setState({
      [modal]: false
    }, cb)
  }

  render() {
    const {
      store: {
        tableData,
        totalCount,
        queryMap,
        currentPageIndex,
      },
    } = this.props
    const { showTaskDetailModal } = this.state
    const renderContent = (text, record, index) => {
      const obj = {
        children: text,
        props: {},
      }

      if (record.state === 0 || record.state === 2 || record.state === 3 || record.state === 4 || record.state === 6) {
        obj.props.colSpan = 0
      }
      return obj
    }

    let stateMap = new Map([
      [0, '初始化'],
      [1, '待运行'],
      [2, '开始运行'],
      [3, '生信程序解析中'],
      [4, '解析成功'],
      [5, '运行成功'],
      [6, '运行失败'],
    ])

    const columns = [
      {
        title: (<div className="ta-l">任务id</div>),
        className: "ta-l",
        dataIndex: "id",
      }, {
        title: (<div className="ta-l">任务状态</div>),
        className: "ta-l",
        dataIndex: "state",
        render: (text, record) => {
          switch (record.state) {
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
              return {
                children: (
                  <Row type="flex" justify="center" align="middle">
                    <div className="running pgs-state-element">
                      <Icon type="hourglass" />
                      {stateMap.get(text)}
                    </div>
                  </Row >
                ),
                props: { colSpan: 6 }
              }
            case 6:
              return {
                children: (
                  <Row type="flex" justify="center" align="middle">
                    <div className="task-run-failed task-state-element">
                      <Icon type="close-circle" />
                      {stateMap.get(text)}，{record.message}
                    </div>
                  </Row>
                ),
                props: { colSpan: 6 }
              }
            case 5:
              return (<div>{stateMap.get(text)}</div>)
            default:
              return (<div>{stateMap.get(text)}</div>)
          }
        }
      }, {
        title: (<div className="ta-l">统计开始时间</div>),
        className: "ta-l",
        dataIndex: "startTime",
        render: renderContent
      }, {
        title: (<div className="ta-l">统计结束时间</div>),
        className: "ta-l",
        dataIndex: "endTime",
        render: renderContent
      }, {
        title: (<div className="ta-l">生信程序执行开始时间</div>),
        className: "ta-l",
        dataIndex: "executeStart",
        render: renderContent
      }, {
        title: (<div className="ta-l">生信程序执行结束时间</div>),
        className: "ta-l",
        dataIndex: "executeEnd",
        render: renderContent
      }, {
        title: (<div className="ta-l">任务创建时间</div>),
        className: "ta-l",
        dataIndex: "createTime",
        render: renderContent
      }, {
        title: (<div className="ta-l">操作</div>),
        className: "ta-l",
        dataIndex: "operator",
        render: (text, record) => {
          return (
            <Button
              type="primary"
              disabled={record.state !== 5}
              onClick={() => this.openDetail(record.id)}
            >
              详情
            </Button>
          )
        }
      }
    ]
    return (
      <div className="table-wrapper-box">
        <Table
          columns={columns}
          className="statistics-table"
          rowKey={record => record.id}
          dataSource={tableData.slice()}
          pagination={{
            pageSize: queryMap.limit,
            onChange: this.onPaginChange,
            defaultCurrent: 1,
            current: currentPageIndex,
            total: totalCount,
          }}
        />
        {/* 详情modal */}
        {showTaskDetailModal &&
          <Modal
            title="任务详情"
            visible
            footer={0}
            width={1172}
            onCancel={() => this.closeModal('showTaskDetailModal')}
            className="task-detail-modal"
          >
            <TaskDetail
              store={this.props.store}
            />
          </Modal>
        }
      </div>
    )
  }
}

export default withRouter(DataTable)


// WEBPACK FOOTER //
// ./src/app/pages/pgs/data_statistics/container/DataTable.js